<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>已审核订单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<div>
					<el-select v-model="query.orderType" placeholder="请选择订单类型" filterable>
						<el-option key="" label="请选择订单类型" value=""></el-option>
						<el-option key="0" label="采购订单" value="0"></el-option>
						<el-option key="1" label="销售订单" value="1"></el-option>
					</el-select>&nbsp;
					<el-input v-model="query.orderNo" placeholder="请输入订单号" class="handle-input mr10"></el-input>&nbsp;
					<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				</div>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
				<el-table-column prop="orderCompanyName" label="供货公司"></el-table-column>
                <el-table-column prop="operator" label="经办人" width="90"></el-table-column>
				<el-table-column prop="total" label="数量" width="60"></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="payType" label="付款方式" :formatter="payTypeFormat" width="100">
					<template slot-scope="scope" v-if="scope.row.status<6">
					<el-tag :type= "(scope.row.payReceipt > '' || scope.row.balancePayment > 0)?'success':((scope.row.payType===2 && new Date(scope.row.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, scope.row.payType)}}
					</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="订单状态" :formatter="statusFormat" width="80"></el-table-column>
				<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="uncheckOrder(scope.$index, scope.row)"
							v-if = "controll['uncheck']"
                        >取消审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchCheckedOrderData, uncheck} from '../../../api/index';
export default {
    name: 'checked-order',
    data() {		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("checked-order");
        this.getData();
    },
    methods: {
		payTypeFormat(row, column, cellValue) {
			let payTypeConfig = {"0":"款到发货", "1":"快递代收", "2":"账期付款"};
			return payTypeConfig[cellValue];
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待付款","2":"待收货","3":"收货中","4":"已到货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchCheckedOrderData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		uncheckOrder(index, row) {
			this.$confirm('确定取消审核吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					uncheck(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success(`取消审核成功！`);
							this.getData();
						} else {
							this.$message.error(`取消审核失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		// 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    width: 40px;
    height: 30px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}
</style>
